var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.section.title))]),_c('Spacer'),_vm._l((_vm.section.rows),function(row,i){return _c('SectionRow',{key:i,attrs:{"row":row}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }